import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=25f88212"
import script from "./OrderInput.vue?vue&type=script&lang=js"
export * from "./OrderInput.vue?vue&type=script&lang=js"
import style0 from "./OrderInput.vue?vue&type=style&index=0&id=25f88212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports